<div class="user-roles-container d-block p-9 mx-9">
  <!--Path Selection-->
  <div class="mx-9" *ngIf="showUserPathSelection">
    <h2 class="mb-6">Please pick a path to move forward</h2>
    <div class="dark-bg cursor-pointer p-9 mb-6 d-flex justify-content-between align-items-center"
      (click)="onUserPathSelect('admin')">
      <h1>
        Admin User
      </h1>
      <i class="far fa-arrow-alt-circle-right font-size-30"></i>
    </div>
    <div class="dark-bg cursor-pointer p-9 mb-6 d-flex justify-content-between align-items-center"
      (click)="onUserPathSelect('party_user')">
      <h1>
        Portal User
      </h1>
      <i class="far fa-arrow-alt-circle-right font-size-30"></i>
    </div>
  </div>
  <!--Division Selection-->
  <div class="mx-9" *ngIf="!showUserPathSelection && showDivisonSelection">
    <h2 class="mb-6">Please pick a division to move forward</h2>
    <div class="dark-bg cursor-pointer p-9 mb-6 d-flex justify-content-between align-items-center"
      (click)="onDivisionSelect(division)" *ngFor="let division of divisionsToShow; let divisionIndex = index;">
      <h1>
        {{ division.name }}
      </h1>
      <i class="far fa-arrow-alt-circle-right font-size-30"></i>
    </div>
  </div>
  <!--Instrument Selection-->
  <div class="mx-9" *ngIf="!showUserPathSelection && !showDivisonSelection && showInstrumentSelection">
    <h2 class="mb-6">Please pick an instrument to move forward</h2>
    <div class="dark-bg cursor-pointer p-9 mb-6 d-flex justify-content-between align-items-center"
      (click)="onInstrumentSelect(instrument)"
      *ngFor="let instrument of instrumentsToShow; let instrumentIndex = index;">
      <h1>
        {{ instrumentNameMap[instrument.instrumentType] }}
      </h1>
      <i class="far fa-arrow-alt-circle-right font-size-30"></i>
    </div>
  </div>
  <!--Role Selections-->
  <div class="mx-9"
    *ngIf="!showUserPathSelection && !showDivisonSelection && !showInstrumentSelection && showRoleSelection">
    <h2 class="mb-6">Please pick a role to move forward</h2>
    <div class="dark-bg cursor-pointer p-9 mb-6 d-flex justify-content-between align-items-center"
      (click)="onRoleSelect(role)" *ngFor="let role of rolesToShow; let roleIndex = index;">
      <h1>
        {{ roleNameMap[role.role_type] }}
      </h1>
      <i class="far fa-arrow-alt-circle-right font-size-30"></i>
    </div>
  </div>
  <div class="mx-9"
    *ngIf="!showUserPathSelection && !showDivisonSelection && !showInstrumentSelection && !showRoleSelection && !isSaved">
    <div class="dark-bg cursor-pointer p-9 mb-6 d-flex justify-content-between align-items-center">
      <h1>
        Loading User Details...
      </h1>
    </div>
  </div>
  <div class="mx-9"
    *ngIf="!showUserPathSelection && !showDivisonSelection && !showInstrumentSelection && !showRoleSelection && isSaved">
    <div class="dark-bg cursor-pointer p-9 mb-6 d-flex justify-content-between align-items-center">
      <h1>
        Redirecting you to your screens...
      </h1>
    </div>
  </div>
</div>
